import { useCallback } from 'react';
import { useAnalytic } from '@skooldio/analytics-provider';

const useExceptionTracking = () => {
  const { ga } = useAnalytic();
  const logError = useCallback(
    (exception) => {
      try {
        ga.exception(exception);
      } catch (error) {
        console.error(error);
      }
    },
    [ga]
  );

  return { logError };
};

export { useExceptionTracking };
